<template>
<div class="product-con">
    <template v-for="(item,index) in infos">
        <product :info="item" :key="index"></product>
    </template>
</div>
</template>

<script>
import product from '@/components/product.vue'
export default {
    data() {
        return {
            infos: [{
                    img: "1491481186.jpg",
                    title: '银行无线预约管理系统'
                },
                {
                    img: "1491529608.jpg",
                    title: '银行库款交接管理系统'
                },
                {
                    img: "1491529939.jpg",
                    title: "银行上面收款管理系统"
                },
                {
                    img: '1491530032.jpg',
                    title: '现金中心管理系统'
                },
                {
                    img: '1491530073.jpg',
                    title: '金易通综合管理平台'
                },
                {
                    img: '1491534756.jpg',
                    title: '人民币反假考试系统'
                },
                {
                    img: '1491563050.jpg',
                    title: '小面额流通管理系统'
                }
            ]
        }
    },
    components: {
        product
    }
}
</script>

<style lang="scss" scoped>
.product-con {
    width: 1120px;
    margin: 0 auto;
    padding: 8px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
}
</style>
